export default [
  {
    url: '/back',
    name: '분야 바로가기',
    icon: 'ArrowLeftIcon',
    activeCode: '',
  },
  {
    url: '/home',
    name: '대시보드',
    icon: '',
    activeCode: '',
  },
  {
    url: '/tab/118/page',
    name: '시스템 계약 현황',
    icon: '',
    activeCode: '',
    groupName: ['118'],
  },
  {
    url: '/',
    name: '현장/시설물 개요',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/field/facility',
        name: '시설물 관리',
        icon: '',
        activeCode: 'field-facility',
      },
    ]
  },
  {
    url: '/',
    name: '안전보건조직체계',
    icon: '',
    activeCode: '',
    submenu: [
      // {
      //   url: '/company/info',
      //   name: '하도급업체 정보',
      //   icon: '',
      //   activeCode: 'company-info',
      // },
      {
        url: '/tab/126',
        name: '안전보건 조직도 등록',
        icon: 'w-line',
        activeCode: '',
        groupName: ['126'],
      },
      {
        url: '/tab/141',
        name: '안전보건 관련 인력',
        icon: 'w-line',
        activeCode: '',
        groupName: ['141'],
      },
      {
        url: '/tab/136',
        name: '안전보건 점검 인력',
        icon: 'w-line',
        activeCode: '',
        groupName: ['136'],
      },
      {
        url: '/tab/137',
        name: '안전보건 점검 계획',
        icon: 'w-line',
        activeCode: '',
        groupName: ['137'],
      },
      {
        url: '/tab/142',
        name: '내부종사자 정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['142'],
      },
      {
        url: '/tab/138',
        name: '비상 연락/지원 체계도',
        icon: 'w-line',
        activeCode: '',
        groupName: ['138'],
      },
      {
        url: '/tab/139',
        name: '유관기관 비상연락망',
        icon: 'w-line',
        activeCode: '',
        groupName: ['139'],
      },
      {
        url: '/tab/285',
        name: '안전보건관리 책임자 지정 외',
        icon: 'w-line',
        activeCode: '',
        groupName: ["285", "282", "491", "524", "525", "526"],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건관리체계',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/109',
        name: '현장 경영방침',
        icon: '',
        activeCode: '',
        groupName: ['109'],
      },
      {
        url: '/tab/149',
        name: '수급인 산재예방 평가',
        icon: '',
        activeCode: '',
        groupName: ['149'],
      },
      {
        url: '/tab/150',
        name: '안전보건 확보 의무',
        icon: '',
        activeCode: '',
        groupName: ['150'],
      },
      {
        url: '/tab/152',
        name: '산업안전보건위원회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['152']
      },
      {
        url: '/tab/153',
        name: '노사협의체',
        icon: 'w-line',
        activeCode: '',
        groupName: ['153']
      },
    ]
  },
  // {
  //   url: '/',
  //   name: '안전보건 예산',
  //   icon: '',
  //   activeCode: '',
  //   submenu: [
  //     {
  //       url: '/tab/155',
  //       name: '안전보건 관련 예산(시설물 유지)',
  //       icon: 'w-line',
  //       activeCode: '',
  //       groupName: ['155'],
  //     },
  //   ]
  // },
  {
    url: '/',
    name: '교육 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/107',
        name: '안전·보건 교육',
        icon: '',
        activeCode: '',
        groupName: ['107'],
      },
      {
        url: '/tab/132/page',
        name: '교육 모니터링',
        icon: 'w-line',
        activeCode: '',
        groupName: ['132'],
      },
    ]
  },
  {
    url: '/',
    name: '유해·위험요인 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: "/tab/331",
        name: "안전개선 제안서",
        icon: "w-line",
        activeCode: "",
        groupName: ["331"],
      },
    ]
  },
  {
    url: '/',
    name: '위험성평가',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/161',
        name: '정기 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['161', '333'],
      },
      {
        url: '/tab/162',
        name: '수시 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['162', '334'],
      },
      {
        url: '/tab/151',
        name: '위험성평가협의회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['151'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 점검',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: "/tab/391",
        name: "안전보건 순회점검 보고서",
        icon: "count",
        activeCode: "",
        groupName: ["391"],
      },
      {
        url: '/tab/100',
        name: '합동 안전점검',
        icon: '',
        activeCode: '',
        groupName: ['100'],
      },
      {
        url: '/tab/163',
        name: '작업장 순회점검일지',
        icon: '',
        activeCode: '',
        groupName: ['163'],
      },
      {
        url: '/tab/110',
        name: '도로 보수',
        icon: '',
        activeCode: '',
        groupName: ['110'],
      },
      {
        url: '/tab/164',
        name: '요양보호사',
        icon: '',
        activeCode: '',
        groupName: ['164'],
      },
      {
        url: '/tab/165',
        name: '종사자 및 주차시설',
        icon: '',
        activeCode: '',
        groupName: ['165'],
      },
      {
        url: '/tab/166',
        name: '냉온수기 및 보일러 설비',
        icon: '',
        activeCode: '',
        groupName: ['166'],
      },
      {
        url: '/tab/167',
        name: '행사자 동선 및 관계자',
        icon: '',
        activeCode: '',
        groupName: ['167'],
      },
      {
        url: '/tab/168',
        name: '시설물 관리(공통)',
        icon: '',
        activeCode: '',
        groupName: ['168'],
      },
      {
        url: '/',
        name: '외 점검표...',
        icon: '',
        activeCode: '',
        groupName: [''],
      }
    ]
  },
  {
    url: '/',
    name: '시설물 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/114',
        name: '시설물 점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['114'],
      },
      {
        url: '/tab/234',
        name: '시설물 진단',
        icon: 'w-line',
        activeCode: '',
        groupName: ['234'],
      },
      {
        url: '/tab/235',
        name: '시설물 보수',
        icon: 'w-line',
        activeCode: '',
        groupName: ['235'],
      },
      {
        url: '/tab/236',
        name: '시설물 보강',
        icon: 'w-line',
        activeCode: '',
        groupName: ['236'],
      },
      {
        url: '/tab/237',
        name: '시설물 교체',
        icon: 'w-line',
        activeCode: '',
        groupName: ['237'],
      },
    ]
  },
  {
    url: '/',
    name: '재해발생 대비 대책',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/116/page',
        name: '(재해발생) 산업재해 발생 시 보고 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['116'],
      },
      {
        url: '/tab/238/page',
        name: '(재해발생) 비상조치 및 처리 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['238'],
      },
      {
        url: '/tab/239',
        name: '비상대피 훈련·교육·자체평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['239', '240', '241'],
      },
      // {
      //   url: '/tab/242',
      //   name: '비상조치계획 수립',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['242'],
      // }
      {
        url: '/tab/492',
        name: '비상사태훈련 결과보고서',
        icon: "count",
        activeCode: '',
        groupName: ['492'],
      },
    ]
  },
  {
    url: '/',
    name: '재해발생보고',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/117',
        name: '산업재해조사표',
        icon: '',
        activeCode: '',
        groupName: ['117'],
      },
      {
        url: '/tab/244',
        name: '중대재해 발생 보고',
        icon: '',
        activeCode: '',
        groupName: ['244'],
      },
      // {
      //   url: '/tab/245',
      //   name: '재발방지계획서',
      //   icon: '',
      //   activeCode: '',
      //   groupName: ['245'],
      // },
      {
        url: '/tab/307',
        name: '안전사고 발생 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['307'],
      },
      {
        url: '/tab/308',
        name: '재발방지 조치 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['308'],
      },
    ]
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "공지사항",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ['94\n' +
            '        groupName: [\'90\'],'],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
]
